/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import styled from "@emotion/styled";
import CouponEditLog from "./CouponEditLog";
import {
  MobileDateTimePicker,
  LocalizationProvider as LocalizationProvider2,
} from "@mui/x-date-pickers";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 레이아웃
const Container = styled(Box)`
  display: flex;
`;

const Left = styled(Box)`
  flex: 1;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 20px;
`;

const Right = styled(Box)`
  padding-top: 10px;
  padding-right: 10px;
  width: 500px;
`;

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState("");
  const [date, setDate] = useState(null);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [pName, setPname] = useState("");
  const [useCount, setUseCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [method, setMethod] = useState("");
  const [pid, setPid] = useState("");
  const [edate, setEdate] = useState(null);
  const [state, setState] = useState("");
  const [sdate, setSdate] = useState(null);
  const [tmcd, setTmcd] = useState("");
  const [cam, setCam] = useState(0);
  const [regdate, setRegdate] = useState(null);

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    seq: seq,
    sdate: "",
    total_count: 0,
    use_count: 0,
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onSubmit = async () => {
    // pr('tmcd='+tmcd);
    // pr('pid='+pid);
    // pr('sdate='+sdate);
    // pr('edate='+edate);
    // pr('totalCount='+totalCount);
    // pr('useCount='+useCount);
    // pr('state='+state);
    let result = await axios.post(
      configState.api + "/gympass_admin/coupon_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        tmcd: tmcd,
        pid: pid,
        sdate: sdate,
        edate: edate,
        total_count: totalCount,
        use_count: useCount,
        state: state,
        total_amount: cam,
        regdate,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  // 회원찾기 팝업
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  // 상품찾기 팝업
  const onShowProductSearchClick = () => {
    setShowProductSearch(true);
  };

  const onHideProductSearchClick = () => {
    setShowProductSearch(false);
  };

  const onAfterProductSearchClick = (params) => {
    const { id, name } = params;
    setPname(name);
    setPid(id);
  };

  const onTotalCountChange = (e) => {
    alert("?");
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/coupon_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: data.seq,
      }
    );
    if (result.data.success === 1) {
      setSname(result.data.row.mb_name);
      setPname(result.data.row.pname);
      setTotalCount(result.data.row.total_count);
      setUseCount(result.data.row.use_count);
      setState(result.data.row.state);
      setSdate(result.data.row.enroll_sdate);
      setEdate(result.data.row.enroll_edate);
      setTmcd(result.data.row.mcd);
      setPid(result.data.row.pid);
      setCam(result.data.row.total_amount);
      setRegdate(result.data.row.regdate);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/coupon_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Container>
      {/* 사용자 찾기 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      {/* 상품 찾기 */}
      <Dialog
        open={showProductSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>상품찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideProductSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ProductSearch
          login={login}
          onAfterProductSearchClick={onAfterProductSearchClick}
          onHideProductSearchClick={onHideProductSearchClick}
        />
      </Dialog>

      <Left>
        <Box>
          {/* 고객명 */}
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              InputProps={{
                readOnly: true,
              }}
              name="name"
              label="고객명"
              size="small"
              sx={{
                width: "180px",
              }}
              autoComplete="off"
              value={sName}
            ></TextField>

            <Button
              variant="contained"
              sx={{ ml: 1 }}
              onClick={onShowMemberSearchClick}
            >
              조회
            </Button>
          </Box>

          {/* 시작일 */}
          <Box sx={{ display: "flex", mt: 1.5 }}>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                <MobileDatePicker
                  allowSameDateSelection={true}
                  value={sdate}
                  label="시작일"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  onChange={(newDate) =>
                    setSdate(moment(newDate).format("YYYY-MM-DD"))
                  }
                  inputFormat={"yyyy.MM.dd"}
                  autoComplete="off"
                />
              </LocalizationProvider>
            </Box>
            <Box sx={{ ml: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                <MobileDatePicker
                  name="edate"
                  allowSameDateSelection={true}
                  value={edate}
                  label="종료일"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  onChange={(newDate) =>
                    setEdate(moment(newDate).format("YYYY-MM-DD"))
                  }
                  inputFormat={"yyyy.MM.dd"}
                  autoComplete="off"
                />
              </LocalizationProvider>
            </Box>
          </Box>

          {/* 상품명 */}
          <Box sx={{ mt: 1.5 }}>
            <TextField
              InputProps={{
                readOnly: true,
              }}
              name="name"
              label="상품명"
              size="small"
              sx={{
                width: "280px",
              }}
              autoComplete="off"
              value={pName}
            ></TextField>
            <Button
              variant="contained"
              sx={{ ml: 1 }}
              onClick={onShowProductSearchClick}
            >
              조회
            </Button>
          </Box>

          {/* 쿠폰금액 */}
          <FormControl fullWidth sx={{ mt: 1.5 }}>
            <TextField
              name="total_amount"
              label="총 쿠폰금액"
              size="small"
              autoComplete="off"
              value={cam}
              sx={{ width: 180 }}
              onChange={(e) => setCam(e.target.value)}
            ></TextField>
          </FormControl>

          {/* 보유 */}
          <FormControl fullWidth sx={{ mt: 1.5 }}>
            <TextField
              name="totalCount"
              label="보유 수량"
              size="small"
              autoComplete="off"
              value={totalCount}
              onChange={(e) => setTotalCount(e.target.value)}
              sx={{ width: 180 }}
            ></TextField>
          </FormControl>

          {/* 사용수량 */}
          <FormControl fullWidth sx={{ mt: 1.5 }}>
            <TextField
              name="use_count"
              label="사용수량"
              size="small"
              autoComplete="off"
              value={useCount}
              sx={{ width: 180 }}
              onChange={(e) => setUseCount(e.target.value)}
            ></TextField>
          </FormControl>

          {/* 상태 */}
          <FormControl fullWidth sx={{ mt: 1, pl: 0.5 }}>
            <FormLabel>상태</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              name="state"
              onChange={(e) => setState(e.target.value)}
              value={state}
            >
              <FormControlLabel value="Y" control={<Radio />} label="Y" />
              <FormControlLabel value="" control={<Radio />} label="N" />
            </RadioGroup>
          </FormControl>

          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <LocalizationProvider2 dateAdapter={AdapterDateFns} locale={ko}>
              <MobileDateTimePicker
                allowSameDateSelection={true}
                views={["year", "month", "day", "hours", "minutes", "seconds"]}
                value={regdate}
                label="등록일 (구매일)"
                renderInput={(params) => <TextField size="small" {...params} />}
                onChange={(dt) => {
                  let dt_format = moment(dt).format("YYYY-MM-DD HH:mm:ss");
                  setRegdate(dt_format);
                }}
                inputFormat={"yyyy.MM.dd hh:mm:ss"}
                autoComplete="off"
              />
            </LocalizationProvider2>
          </Box>

          <Box
            css={css`
              text-align: center;
              margin-top: 30px;
            `}
          >
            {login.level === "500" && (
              <Button variant="contained" onClick={onSubmit}>
                수정완료
              </Button>
            )}

            <Button
              variant="contained"
              css={css`
                margin-left: 10px;
              `}
              onClick={onClosePop}
            >
              닫기
            </Button>

            {login.level === "500" && (
              <Button
                variant="contained"
                color="warning"
                css={css`
                  margin-left: 10px;
                `}
                onClick={onDeleteClick}
              >
                삭제
              </Button>
            )}
          </Box>
        </Box>
      </Left>
      <Right>
        <CouponEditLog login={login} coupon_seq={seq}></CouponEditLog>
      </Right>
    </Container>
  );
}

export default OrderEdit;
